<template>
  <Meta
    name="twitter:title"
    :content="gameData?.meta_title"
    v-if="gameData?.meta_title"
  />
  <Meta
    name="twitter:description"
    :content="
      ['path-of-exile-2-boost', 'fc-boost'].includes(gameSlug)
        ? gameData?.page_description
        : gameData?.description
    "
    v-if="gameData?.description"
  />
  <Meta
    name="og:description"
    :content="
      ['path-of-exile-2-boost', 'fc-boost'].includes(gameSlug)
        ? gameData?.page_description
        : gameData?.description
    "
    v-if="gameData?.description"
  />
  <Meta
    name="og:title"
    :content="gameData?.meta_title"
    v-if="gameData?.meta_title"
  />
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    v-if="'gta-6-boost' === $route.params.gameSlug"
    alt="Boostingmarket.com website background image"
  />
  <Meta
    name="og:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=11`"
  />
  <Meta
    name="twitter:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=11`"
  />
  <!-- <p class="t-white">{{ gameSlug }}</p> -->
  <Boosting
    v-if="
      ![
        'world-of-warcraft-boost',
        'gta-6-boost',
        'path-of-exile-2-boost',
        'fc-boost',
      ].includes($route.params.gameSlug)
    "
  />

  <GtaOverview v-else-if="'gta-6-boost' === $route.params.gameSlug" />
  <MmoBoosting
    v-else-if="$route.params.gameSlug === 'world-of-warcraft-boost'"
  />
  <NestBoosting
    v-else-if="
      ['path-of-exile-2-boost', 'fc-boost'].includes($route.params.gameSlug)
    "
  />
</template>

<script setup>
import Boosting from "~/components/page/Boosting.vue";
import MmoBoosting from "~/components/page/MmoBoosting.vue";
import GtaOverview from "~/components/page/GtaOverview.vue";
import NestBoosting from "~/components/page/NestBoosting.vue";
import { watch, ref } from "vue";
const router = useRouter();
const route = router.currentRoute;
const gameData = ref(null);
const { getUtm } = useUserStore();
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "boosting-game-page",
  },

  // middleware: ["load-game"],
});

const { setGamePack, getGame, apiGetGame, apiGetGameRanks, resetHeroes } =
  useGameStore();

const { currentGameSlug } = useGameComposable();
const { clearCheckout } = useCheckoutStore();
const { locale } = useI18n();

const nuxtApp = useNuxtApp();

const gameSlug = route.value?.params?.gameSlug || "";
const gamePackSlug = route.value?.params?.gamePackSlug || "";

const mmoGames = ["world-of-warcraft-boost"];
let path = "get-game-pack";

const localePath = useLocalePath();
if (mmoGames.includes(gameSlug)) {
  path = "get-mmo-game-pack";
}

const localeChange = ref(false);
const {
  data: response,
  error,
  refresh,
} = await useApiFetch(`/api/${path}/${gamePackSlug}`, {
  method: "post",
  fetchKey: `get-game-pack-${gamePackSlug}-${locale.value}`,
  body: {
    params: ["faqs", "pack_options", "pack_extra_options", "prices"],
    locale: locale.value,
    gameSlug: gameSlug,
  },
  // lazy: true,
  transform(input) {
    return {
      data: input.data,
      fetchedAt: new Date(),
    };
  },
  getCachedData(key) {
    const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key];
    if (!data) {
      return;
    }
    if (localeChange?.value) {
      localeChange.value = false;
      return;
    }
    const expirationDate = new Date(data.fetchedAt);
    expirationDate.setTime(expirationDate.getTime() + 22160000);
    const isExpired = expirationDate.getTime() < Date.now();
    if (isExpired) {
      return;
    }

    // Explicitly update the response to trigger reactivity
    // response.value = { ...data }; // Spread to create a new object
    return data;
  },
});

const handleSnippet = () => {
  let schema = document.createElement("script");
  schema.type = "application/ld+json";

  const reviewCount = gameData.value?.reviews || 500;
  let script = document.createTextNode(
    '{"@context": "https://schema.org/", "@type": "Product", "name": "' +
      gameData.value.title +
      '", "image": "' +
      gameData.value.image +
      '", "description": "' +
      gameData.value.description +
      '", "brand": { "@type": "Brand", "name": "Boostingmarket.com" }, "offers": { "@type": "AggregateOffer", "url": "https://boostingmarket.com' +
      route.value.path +
      `", "priceCurrency": "USD", "lowPrice": "0.99", "highPrice": "299.99", "offerCount": "1" }, "aggregateRating": {"@type": "AggregateRating", "ratingValue": "4.9", "bestRating": "5", "worstRating": "1", "ratingCount": "${reviewCount}"}}`
  );
  schema.appendChild(script);
  document.head.appendChild(schema);

  if (gameData.value?.faqs?.length > 0) {
    let schema = document.createElement("script");
    schema.type = "application/ld+json";
    let faqs = "";
    gameData.value.faqs.forEach((faq, key) => {
      //console.log(key);
      if (key !== 0) {
        faqs += ",";
      }
      faqs +=
        '{"@type": "Question", "name": "' +
        faq.question +
        '", "acceptedAnswer": {"@type": "Answer","text": "<p>' +
        faq.answer +
        '</p>"}}';
    });
    let script = document.createTextNode(
      '{"@context": "https://schema.org/", "@type": "FAQPage", "mainEntity": [' +
        faqs +
        "]}"
    );
    schema.appendChild(script);
    document.head.appendChild(schema);
  }
};

apiGetGame({
  gameSlug: gameSlug,
  locale: locale?.value,
});
await apiGetGameRanks({
  gameSlug: gameSlug,
  locale: locale?.value,
});

if (error.value?.data && currentGameSlug !== "world-of-warcraft-boost") {
  throw createError({
    statusCode: "404",
    statusMessage: "Not Found",
  });
}
if (response.value?.data) {
  setGamePack(response.value?.data);
  gameData.value = response.value?.data;
  useSeoMeta({
    title: response.value?.data?.meta_title,
    description: ["path-of-exile-2-boost", "fc-boost"].includes(currentGameSlug)
      ? response.value?.data?.page_description
      : response.value?.data?.description,
  });
}

watch(route, (newVal) => {
  if (!newVal.params?.gamePackSlug) {
    clearCheckout();
  }
});
watch(response, (newVal) => {
  setGamePack(newVal?.data);
  gameData.value = newVal?.data;
  useSeoMeta({
    title: newVal?.data?.meta_title,
    // description: newVal?.data?.description,
    description: ["path-of-exile-2-boost", "fc-boost"].includes(currentGameSlug)
      ? newVal?.data?.page_description
      : newVal?.data?.description,
  });
});
watch(error, (newVal) => {
  if (newVal?.data && currentGameSlug !== "world-of-warcraft-boost") {
    throw createError({
      statusCode: "404",
      statusMessage: "Not Found",
    });
  }
});
addCanonicalLink(route.value.fullPath);
onNuxtReady(() => {
  if (response.value?.data) {
    const utmDataSet = getUtm;

    window?.analytics?.page("Game Pack Page", {
      title: response.value?.data?.meta_title,
      ...utmDataSet,
    });
    handleSnippet();
  }
});

watch(locale, () => {
  localeChange.value = true;
});
watch(response, (newVal) => {
  if (newVal?.data) {
    const utmDataSet = getUtm;
    window?.analytics?.page("Game Pack Page", {
      title: newVal?.data?.meta_title,
      ...utmDataSet,
    });
    handleSnippet();
  }
});
</script>
